// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import rem from './utils/rem'
import emoji from './utils/emoji'
import Vconsloe from 'vconsole'
import {Toast} from 'vant'
import { storeName, prodCatalogId, severUrl,  whiteList,  } from '@/router/Constant'
import { setStore, getStore, getCookie, setCookie,delCookie, GetQueryString ,getQueryVariable} from '@/utils/mUtil'
import { login, checkLogin, boundTwoLevel } from '@/router/api'
import VueWechatTitle from 'vue-wechat-title'
import {removeStore} from "./utils/mUtil";

Vue.directive('emoji',emoji)

// vConsole
if (severUrl != 'https://dms.hellokittypark.cn' && severUrl != 'https://kitty.choicelean.com') {
  Vue.config.productionTip = false
  let vConsole = new Vconsloe()
  Vue.use(vConsole)
}

// getWidth
if (severUrl != 'https://dms.hellokittypark.cn') {
  // console.log('document.body.clientWidth' + document.body.clientWidth)
  // console.log('window.screen.height' + window.screen.height)
  // console.log('document.body.offsetWidth' + document.body.offsetWidth)
  // console.log('window.innerWidth' + window.innerWidth)
  // console.log('window.outerWidth' + window.outerWidth)
  // console.log('window.screen.width' + window.screen.width)
  // console.log('window.screen.availWidth' + window.screen.availWidth)
}

// 设置相关title
Vue.use(VueWechatTitle)

// debugger
// // 设置模拟cookie
// setCookie('authorization', 'eyJhbGciOiJIUzUxMiJ9.eyJhdXRoIjoiIiwib3BlbmlkIjoibzdkejEwNV9Ud1ZLZXB0V01neVJoVU5LejlZNCIsImlkIjo0OTQsInVzZXJOYW1lIjoibzdkejEwNV9Ud1ZLZXB0V01neVJoVU5LejlZNCIsImV4cCI6MTYwODQ1MTEyNX0.3UWu6msw5YhHWZZEGouFmI48ksuH3jiNppxZamzhLNfCfwHPGgiyuYU6R2eWjFK1be3F1KpgTZGyP28QpDDfMw')
// setStore('externalLoginKey', 'EL298e99b5-a45d-4745-a532-c5156e807703')

function creatVue () {
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
}

// 此function只供开发测试人员调用。其他人不要随意更改
function autoLoginAction() {
  // login({USERNAME:'LP00004256',PASSWORD:'kitty@password'})
  login({USERNAME:'external_120',PASSWORD:'[EXTERNAL]'})
    .then(res => {
      console.log("login")
      console.log(res)
      if (res._TOKEN_){
        setStore('externalLoginKey',res._TOKEN_)
        setStore('islogIn',true)
        console.log('登录成功')
        creatVue();
      }
    })
    .catch(err => {
      console.log(err);
    });
}

function loginActionFromMini () {
  console.log("当前href========"+window.location.href)
  window.location.href = window.location.href.replace('?','?&')
  console.log("修改后href======="+window.location.href)
  var externalLoginKey;
  externalLoginKey = getQueryVariable('externalLoginKey')
  if (externalLoginKey != '' && externalLoginKey != null && externalLoginKey != undefined) {
    if(getQueryVariable('unionId')!="") {
      var unionId = getQueryVariable('unionId');
        setStore('unionId', unionId)
    }
    setStore('externalLoginKey', externalLoginKey)
    setStore('islogIn', true)
    console.log('用户已登录')
    creatVue();
    if(storeName == 'OnlineStore'||storeName=='GiftCardStore') {
      var url = window.location.href
      window.location.href = url
    }
  }else{
    // alert('没有登录')
    console.log('没有获取到用户，现在是自动登陆的用户')
    autoLoginAction();
    // alert('没有获取到用户，请联系客服')
    console.log('没有获取到用户')
    Toast('页面出现了问题，请联系客服，3s后自动跳转小程序')
    setTimeout(() => {
      wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
    }, 3000);
  }
}

function loginActionFromH5() {
  // debugger
  console.log("Bearer "+ getCookie('authorization'))
  login({token:"Bearer "+ getCookie('authorization')})
    .then(res => {
      console.log("login")
      console.log(res)
      if (res._TOKEN_){
        setStore('externalLoginKey',res._TOKEN_)
        setStore('islogIn',true)
        console.log('登录成功')
        creatVue();
        if(storeName == 'OnlineStore') {
          if(window.location.href.indexOf('goods')!=-1){
            console.log( window.location.href + 'main.js')
            var url = window.location.href
            window.location.href = url
          }else{
            console.log( getStore('currentUrl') + 'main.jscurrentUrl')
            var url = getStore('currentUrl');
            window.location.href = url
          }
        }
      } else {
        if (res._ERROR_CODE_ == 'NoUser'){
          // Toast('请先去领卡'+ '当前token' + getCookie('authorization'))
          setStore('currentUrl',window.location.href)
          creatVue();
          // window.location.href = loginUrl
        } else {
          Toast(res._ERROR_MESSAGE_)
          // Toast('登录失败了当前')
          setStore('currentUrl',window.location.href)
          creatVue();
          var url = getStore('currentUrl');
          window.location.href = url
        }
      }
    })
    .catch(err => {
      console.log(err);
    });
}

function checkLoginAction() {
  console.log(11111)
  console.log(window.location.href)
  setStore('channel',"")
  // debugger
  console.log("onRefresh===========" + getStore('onRefresh'))
  if (window.location.href.indexOf('externalLoginKey') != -1||getStore('onRefresh')=='onRefresh') {
    // 说明是从小程序里面进来的
    console.log("FromUrl==========当前是从小程序里面进来的")
    setStore('fromType', "mini")
    if (getStore('onRefresh')=='onRefresh') {
      console.log("onRefreshAction")
      removeStore('onRefresh')
    }
    var channerl = getQueryVariable("channel")
    if (channerl != "") {
      setStore('channel',channerl)
    }
    loginActionFromMini();
  } else if (getCookie('authorization') != undefined && getCookie('authorization') != null && getCookie('authorization') != '') {
    // 说明是从H5的webpower里面进来的
    console.log("FromUrl==========当前是从webpower里面进来的")
    setStore('fromType', "webpower")
    // setStore('currentUrl', window.location.href)
    // loginActionFromH5()
    setCookie("authorization",'')
    console.log('自动跳转新版本');
    creatVue()
    setTimeout(() => {
      // wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
      var url = window.location.href
      console.log("url===="+url)
      window.location.href = url
    }, 2000);
  } else if (getStore('testChoicelean')) {
    console.log('没有获取到用户')
    autoLoginAction()
  } else if (window.location.href.indexOf('gameId') != -1) {
    //跳转到大转盘游戏
    console.log('game')
    setStore('fromType', "mini")
    // 大转盘游戏 正式修改
    setStore('islogIn', false)

    creatVue()
    var url = window.location.href
    console.log("url===="+url)
    window.location.href = url
  } else if (window.location.href.indexOf('classList') != -1) {
    //萌娃课堂
    console.log('classList')
    setStore('fromType', "H5")
    setStore('islogIn', false)
    creatVue()
    var url = window.location.href
    console.log("url===="+url)
    window.location.href = url
  } else if (getCookie('authorization')==undefined ||getCookie('authorization')=="" ) {
    // 说明从H5的webpower里面进来的，且webpower未登陆
    setStore('fromType', "webpower")
    console.log("FromUrl==========当前是从webpower里面进来的，且还未登录")
    setStore('currentUrl',window.location.href)
    console.log('自动跳转新版本');
    setCookie("authorization",'')
    creatVue()
    setTimeout(() => {

      // wx.miniProgram.switchTab({url:'../../pages/menu/menu'})

      var url = window.location.href
      console.log("url===="+url)
      window.location.href = url
    }, 2000);
  }
}

// autoLoginAction()
checkLoginAction()

// 上传正式需要修改  183行  islogIn true 修改为 false
//                 218行 autoLoginAction()注释 checkLoginAction()释放



// WEBPACK FOOTER //
// ./src/main.js